import React from 'react';

const DeftForm = () => {
  return (
    <iframe
      src="/deftform.html"
      style={{
        width: '100%',
        minHeight: '1200px',
        border: 'none',
        background: 'transparent'
      }}
      title="Contact Form"
    />
  );
};

export default DeftForm;
